import React from 'react'

import { BusyButton } from '@ztechapps/webui.button'
import { useTrackEvent } from '@ztechapps/webui.telemetry'

import { useConversationWidgetContext } from './ConversationWidget'

type ContactUsButtonProps = {
  buttonProps?: Record<string, unknown>
  text?: string
}

export const ContactUsButton = ({ buttonProps, text = 'Contact Us' }: ContactUsButtonProps = {}) => {
  const trackEvent = useTrackEvent()
  const { openConversationWidget } = useConversationWidgetContext()

  const onClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    trackEvent('Contact Us Button')
    openConversationWidget()
  }

  return <BusyButton {...buttonProps} onClick={onClick} text={text} icon={'envelope'} />
}
